export enum LockResult {
    AlreadyLockedByCurrentUser = 'ALREADY_LOCKED_BY_CURRENT_USER',
    AlreadyLockedByOtherUser = 'ALREADY_LOCKED_BY_OTHER_USER',
    Unlocked = 'UNLOCKED',
    LockedSuccessfully = 'LOCKED_SUCCESSFULLY'
}
